export const purpurColorPurple50 = "#faf0ff";
export const purpurColorPurple100 = "#f4e0ff";
export const purpurColorPurple200 = "#e4b6fb";
export const purpurColorPurple300 = "#d58df9";
export const purpurColorPurple400 = "#c461f7";
export const purpurColorPurple500 = "#b12df4";
export const purpurColorPurple550 = "#990ae3";
export const purpurColorPurple600 = "#8c07d0";
export const purpurColorPurple700 = "#6d02a3";
export const purpurColorPurple800 = "#4e0174";
export const purpurColorPurple900 = "#29003e";
export const purpurColorPurple950 = "#1f002e";
export const purpurColorBeige50 = "#f9f1ec";
export const purpurColorBeige100 = "#ede1d8";
export const purpurColorBeige200 = "#d7c3b5";
export const purpurColorBeige300 = "#bba494";
export const purpurColorBeige400 = "#a08877";
export const purpurColorBeige500 = "#807268";
export const purpurColorBeige600 = "#665e58";
export const purpurColorBeige700 = "#4f4741";
export const purpurColorBeige800 = "#3b332d";
export const purpurColorBeige900 = "#2d2824";
export const purpurColorBeige950 = "#170f09";
export const purpurColorTeal50 = "#edf5f5";
export const purpurColorTeal100 = "#d5eae9";
export const purpurColorTeal200 = "#a1cfcd";
export const purpurColorTeal300 = "#6eb5b2";
export const purpurColorTeal400 = "#3a9b96";
export const purpurColorTeal500 = "#00847e";
export const purpurColorTeal600 = "#006c67";
export const purpurColorTeal700 = "#02534f";
export const purpurColorTeal800 = "#063c39";
export const purpurColorTeal900 = "#032220";
export const purpurColorTeal950 = "#011413";
export const purpurColorGray50 = "#f5f5fa";
export const purpurColorGray100 = "#e5e5eb";
export const purpurColorGray150 = "#d6d6dd";
export const purpurColorGray200 = "#c6c6cd";
export const purpurColorGray300 = "#aaaab0";
export const purpurColorGray400 = "#8d8d94";
export const purpurColorGray500 = "#757579";
export const purpurColorGray600 = "#5f5f63";
export const purpurColorGray700 = "#4a4a4d";
export const purpurColorGray800 = "#353537";
export const purpurColorGray850 = "#2a2a2c";
export const purpurColorGray900 = "#202022";
export const purpurColorGray950 = "#121212";
export const purpurColorGreen50 = "#e1f9ec";
export const purpurColorGreen100 = "#c5efd9";
export const purpurColorGreen200 = "#79d9a7";
export const purpurColorGreen300 = "#3dbf7c";
export const purpurColorGreen400 = "#1fa15e";
export const purpurColorGreen500 = "#018842";
export const purpurColorGreen600 = "#017037";
export const purpurColorGreen700 = "#02562b";
export const purpurColorGreen800 = "#003e1e";
export const purpurColorGreen900 = "#002411";
export const purpurColorGreen950 = "#00150a";
export const purpurColorRed50 = "#fff0f5";
export const purpurColorRed100 = "#ffdde8";
export const purpurColorRed200 = "#ffafc9";
export const purpurColorRed300 = "#ff80ab";
export const purpurColorRed400 = "#fb4885";
export const purpurColorRed500 = "#e4175c";
export const purpurColorRed600 = "#c00543";
export const purpurColorRed700 = "#980233";
export const purpurColorRed800 = "#700025";
export const purpurColorRed900 = "#440016";
export const purpurColorRed950 = "#2c000e";
export const purpurColorOrange50 = "#fff2de";
export const purpurColorOrange100 = "#ffe1b3";
export const purpurColorOrange200 = "#f9bb5b";
export const purpurColorOrange300 = "#f39200";
export const purpurColorOrange400 = "#cc7a00";
export const purpurColorOrange500 = "#a86602";
export const purpurColorOrange600 = "#8b5301";
export const purpurColorOrange700 = "#6a4102";
export const purpurColorOrange800 = "#4c2f03";
export const purpurColorOrange900 = "#2b1b03";
export const purpurColorOrange950 = "#1a0f00";
export const purpurColorBlue50 = "#e8f6ff";
export const purpurColorBlue100 = "#caeaff";
export const purpurColorBlue200 = "#91cdf4";
export const purpurColorBlue300 = "#62b2e7";
export const purpurColorBlue400 = "#3694d3";
export const purpurColorBlue500 = "#0078cb";
export const purpurColorBlue600 = "#0063a6";
export const purpurColorBlue700 = "#014d80";
export const purpurColorBlue800 = "#03385b";
export const purpurColorBlue900 = "#002036";
export const purpurColorBlue950 = "#011320";
export const purpurColorTransparentBlack50 = "rgba(0, 0, 0, 0.05)";
export const purpurColorTransparentBlack100 = "rgba(0, 0, 0, 0.1)";
export const purpurColorTransparentBlack150 = "rgba(0, 0, 0, 0.16)";
export const purpurColorTransparentBlack200 = "rgba(0, 0, 0, 0.22)";
export const purpurColorTransparentBlack300 = "rgba(0, 0, 0, 0.33)";
export const purpurColorTransparentBlack400 = "rgba(0, 0, 0, 0.44)";
export const purpurColorTransparentBlack500 = "rgba(0, 0, 0, 0.54)";
export const purpurColorTransparentBlack600 = "rgba(0, 0, 0, 0.62)";
export const purpurColorTransparentBlack700 = "rgba(0, 0, 0, 0.71)";
export const purpurColorTransparentBlack800 = "rgba(0, 0, 0, 0.8)";
export const purpurColorTransparentBlack850 = "rgba(0, 0, 0, 0.84)";
export const purpurColorTransparentBlack900 = "rgba(0, 0, 0, 0.88)";
export const purpurColorTransparentBlack950 = "rgba(0, 0, 0, 0.93)";
export const purpurColorTransparentWhite50 = "rgba(255, 255, 255, 0.07)";
export const purpurColorTransparentWhite100 = "rgba(255, 255, 255, 0.11)";
export const purpurColorTransparentWhite150 = "rgba(255, 255, 255, 0.16)";
export const purpurColorTransparentWhite200 = "rgba(255, 255, 255, 0.21)";
export const purpurColorTransparentWhite300 = "rgba(255, 255, 255, 0.29)";
export const purpurColorTransparentWhite400 = "rgba(255, 255, 255, 0.37)";
export const purpurColorTransparentWhite500 = "rgba(255, 255, 255, 0.46)";
export const purpurColorTransparentWhite600 = "rgba(255, 255, 255, 0.55)";
export const purpurColorTransparentWhite700 = "rgba(255, 255, 255, 0.66)";
export const purpurColorTransparentWhite800 = "rgba(255, 255, 255, 0.79)";
export const purpurColorTransparentWhite850 = "rgba(255, 255, 255, 0.84)";
export const purpurColorTransparentWhite900 = "rgba(255, 255, 255, 0.89)";
export const purpurColorTransparentWhite950 = "rgba(255, 255, 255, 0.95)";
export const purpurColorFunctionalBlack = "#000000";
export const purpurColorFunctionalWhite = "#ffffff";
export const purpurColorFunctionalTransparent = "rgba(255, 255, 255, 0)";
export const purpurColorBrandDeepPurple = "#f4e0ff";
export const purpurColorBrandCorePurple = "#c461f7";
export const purpurColorBrandLightPurple = "#29003e";
export const purpurColorBrandDeepBeige = "#ede1d8";
export const purpurColorBrandBeige = "#4f4741";
export const purpurColorBrandLightBeige = "#3b332d";
export const purpurColorBrandOffBlack = "#ffffff";
export const purpurColorBrandWhite = "#202022";
export const purpurColorTextDefault = "rgba(255, 255, 255, 0.95)";
export const purpurColorTextMedium = "rgba(255, 255, 255, 0.66)";
export const purpurColorTextWeak = "rgba(255, 255, 255, 0.37)";
export const purpurColorTextDefaultNegative = "rgba(0, 0, 0, 0.8)";
export const purpurColorTextMediumNegative = "rgba(0, 0, 0, 0.54)";
export const purpurColorTextWeakNegative = "rgba(0, 0, 0, 0.44)";
export const purpurColorTextInteractivePrimary = "#f4e0ff";
export const purpurColorTextInteractivePrimaryHover = "#faf0ff";
export const purpurColorTextInteractivePrimaryActive = "#ffffff";
export const purpurColorTextInteractiveOnPrimary = "#4e0174";
export const purpurColorTextInteractiveOnPrimaryNegative = "#ffffff";
export const purpurColorTextInteractivePrimaryNegative = "#6d02a3";
export const purpurColorTextInteractivePrimaryHoverNegative = "#4e0174";
export const purpurColorTextInteractivePrimaryActiveNegative = "#29003e";
export const purpurColorTextInteractiveOnExpressive = "#ffffff";
export const purpurColorTextInteractiveOnExpressiveNegative = "#ffffff";
export const purpurColorTextInteractiveOnExpressiveHover = "#29003e";
export const purpurColorTextInteractiveOnExpressiveHoverNegative = "#ffffff";
export const purpurColorTextInteractiveOnExpressiveActive = "#29003e";
export const purpurColorTextInteractiveOnExpressiveActiveNegative = "#ffffff";
export const purpurColorTextInteractiveOnDestructive = "#ffffff";
export const purpurColorTextInteractiveSelected = "#d58df9";
export const purpurColorTextInteractiveSelectedNegative = "#990ae3";
export const purpurColorTextStatusDiscount = "#d58df9";
export const purpurColorTextStatusErrorStrong = "#ffafc9";
export const purpurColorTextStatusErrorStrongNegative = "#980233";
export const purpurColorTextStatusErrorMedium = "#fb4885";
export const purpurColorTextStatusErrorMediumNegative = "#e4175c";
export const purpurColorTextStatusSuccessStrong = "#79d9a7";
export const purpurColorTextStatusSuccessStrongNegative = "#02562b";
export const purpurColorTextStatusSuccessMedium = "#1fa15e";
export const purpurColorTextStatusWarningStrong = "#f9bb5b";
export const purpurColorTextStatusWarningMedium = "#f39200";
export const purpurColorTextStatusWarningMediumNegative = "#a86602";
export const purpurColorTextStatusInfoStrong = "#91cdf4";
export const purpurColorTextStatusInfoMedium = "#3694d3";
export const purpurColorTextStatusNeutral = "#ffffff";
export const purpurColorTextStatusSpecial = "#ffffff";
export const purpurColorTextStatusAttention = "#4e0174";
export const purpurColorTextStatusBlackFriday = "#202022";
export const purpurColorTextToneOnTonePrimary = "#29003e";
export const purpurColorTextToneOnToneSecondary = "#f4e0ff";
export const purpurColorTextToneOnToneTertiary = "#ffffff";
export const purpurColorBackgroundPrimary = "#121212";
export const purpurColorBackgroundPrimaryNegative = "#ffffff";
export const purpurColorBackgroundSecondary = "#202022";
export const purpurColorBackgroundSecondaryNegative = "#f5f5fa";
export const purpurColorBackgroundOnImage = "rgba(0, 0, 0, 0.71)";
export const purpurColorBackgroundOnImageNegative = "rgba(255, 255, 255, 0.84)";
export const purpurColorBackgroundInteractiveAutoFill = "#4e0174";
export const purpurColorBackgroundInteractivePrimary = "#f4e0ff";
export const purpurColorBackgroundInteractivePrimaryHover = "#e4b6fb";
export const purpurColorBackgroundInteractivePrimaryActive = "#d58df9";
export const purpurColorBackgroundInteractivePrimaryNegative = "#4e0174";
export const purpurColorBackgroundInteractivePrimaryHoverNegative = "#6d02a3";
export const purpurColorBackgroundInteractivePrimaryActiveNegative = "#8c07d0";
export const purpurColorBackgroundInteractiveExpressive = "#990ae3";
export const purpurColorBackgroundInteractiveExpressiveHover = "#c461f7";
export const purpurColorBackgroundInteractiveExpressiveActive = "#d58df9";
export const purpurColorBackgroundInteractiveExpressiveNegative = "#990ae3";
export const purpurColorBackgroundInteractiveExpressiveHoverNegative = "#6d02a3";
export const purpurColorBackgroundInteractiveExpressiveActiveNegative = "#4e0174";
export const purpurColorBackgroundInteractiveDisabled = "rgba(255, 255, 255, 0.11)";
export const purpurColorBackgroundInteractiveDisabledNegative = "rgba(0, 0, 0, 0.1)";
export const purpurColorBackgroundInteractiveTransparentHover = "#4e0174";
export const purpurColorBackgroundInteractiveTransparentHoverNegative = "#e4b6fb";
export const purpurColorBackgroundInteractiveTransparentActive = "#6d02a3";
export const purpurColorBackgroundInteractiveTransparentActiveNegative = "#d58df9";
export const purpurColorBackgroundInteractiveInactive = "rgba(255, 255, 255, 0.16)";
export const purpurColorBackgroundInteractiveInactiveNegative = "rgba(0, 0, 0, 0.05)";
export const purpurColorBackgroundInteractiveReadOnly = "rgba(255, 255, 255, 0.07)";
export const purpurColorBackgroundInteractiveReadOnlyNegative = "rgba(0, 0, 0, 0.05)";
export const purpurColorBackgroundInteractiveDestructive = "#e4175c";
export const purpurColorBackgroundInteractiveDestructiveHover = "#c00543";
export const purpurColorBackgroundInteractiveDestructiveActive = "#980233";
export const purpurColorBackgroundStatusInfoMedium = "#03385b";
export const purpurColorBackgroundStatusInfoStrong = "#62b2e7";
export const purpurColorBackgroundStatusSuccessMedium = "#003e1e";
export const purpurColorBackgroundStatusSuccessStrong = "#3dbf7c";
export const purpurColorBackgroundStatusSuccessStrongNegative = "#1fa15e";
export const purpurColorBackgroundStatusErrorMedium = "#700025";
export const purpurColorBackgroundStatusErrorStrong = "#ff80ab";
export const purpurColorBackgroundStatusErrorStrongNegative = "#fb4885";
export const purpurColorBackgroundStatusWarningMedium = "#4c2f03";
export const purpurColorBackgroundStatusWarningStrong = "#f39200";
export const purpurColorBackgroundStatusWarningStrongNegative = "#f39200";
export const purpurColorBackgroundStatusNeutral = "#353537";
export const purpurColorBackgroundStatusSpecial = "#6d02a3";
export const purpurColorBackgroundStatusAttention = "#f4e0ff";
export const purpurColorBackgroundStatusBlackFriday = "#ffffff";
export const purpurColorBackgroundToneOnTonePrimary = "#f4e0ff";
export const purpurColorBackgroundToneOnToneSecondary = "#29003e";
export const purpurColorBackgroundToneOnToneTertiary = "#4f4741";
export const purpurColorBackgroundToneOnToneQuaternary = "#2d2824";
export const purpurColorBorderMedium = "rgba(255, 255, 255, 0.29)";
export const purpurColorBorderMediumNegative = "rgba(0, 0, 0, 0.33)";
export const purpurColorBorderStrong = "rgba(255, 255, 255, 0.46)";
export const purpurColorBorderStrongNegative = "rgba(0, 0, 0, 0.54)";
export const purpurColorBorderWeak = "rgba(255, 255, 255, 0.16)";
export const purpurColorBorderWeakNegative = "rgba(0, 0, 0, 0.16)";
export const purpurColorBorderInteractiveFocus = "#c461f7";
export const purpurColorBorderInteractivePrimary = "#f4e0ff";
export const purpurColorBorderInteractivePrimaryNegative = "#6d02a3";
export const purpurColorBorderInteractivePrimaryHover = "#faf0ff";
export const purpurColorBorderInteractivePrimaryActive = "#ffffff";
export const purpurColorBorderInteractivePrimaryHoverNegative = "#4e0174";
export const purpurColorBorderInteractivePrimaryActiveNegative = "#29003e";
export const purpurColorBorderInteractiveExpressive = "#990ae3";
export const purpurColorBorderInteractiveSelected = "#d58df9";
export const purpurColorBorderInteractiveSubtle = "rgba(255, 255, 255, 0.37)";
export const purpurColorBorderInteractiveSubtleNegative = "rgba(0, 0, 0, 0.44)";
export const purpurColorBorderInteractiveSubtleHover = "#e4b6fb";
export const purpurColorBorderInteractiveSubtleHoverNegative = "#6d02a3";
export const purpurColorBorderStatusError = "#fb4885";
export const purpurColorBorderStatusErrorNegative = "#e4175c";
export const purpurColorBorderStatusWarning = "#f39200";
export const purpurColorBorderStatusInfo = "#3694d3";
export const purpurColorBorderStatusSuccess = "#1fa15e";
export const purpurColorBorderStatusSuccessNegative = "#018842";
export const purpurColorOverlayDefault = "rgba(0, 0, 0, 0.71)";
export const purpurColorGradientAiBottom = "#62b2e7";
export const purpurColorGradientAiBottomNegative = "#3694d3";
export const purpurColorGradientAiTop = "#d58df9";
export const purpurColorGradientAiTopNegative = "#b12df4";
